import {
  Breadcrumbs,
  Link,
  TextField,
  Typography,
  withWidth,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ContactInfoBadge from "../../../Components/Contacts/ContactInfoBadge";
import SortableTable from "../../../Components/SortableTable";
import Title from "../../../Components/Title";
import {
  findValueInText,
  getToken,
  requestErrorHandler,
} from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";
import { useStyles } from "../../../Utils/Styles";

const server = EnvSettings.server;

function SupplierCompanies({ width }) {
  const classes = useStyles();
  const history = useHistory();
  const [companiesList, setCompaniesList] = useState([]);
  const [searchList, setSearchList] = useState();
  const [search, setSearch] = useState();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const getCompanies = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken(), search_value: "" }),
    };
    fetch(server + "/get_supplier_companies", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setCompaniesList(result.companies);
        }
      });
  };

  const showCompany = (company) => {
    history.push("/cpanel/resupply/suppliers/" + company.id);
  };

  const filterResults = () => {
    if (!companiesList) {
      return;
    }
    setSearchList(
      companiesList.filter((company) => {
        return (
          findValueInText(company.name, search) ||
          findValueInText(company.location, search) ||
          findValueInText(company.additionalInfo, search)
        );
      }),
    );
  };

  useEffect(getCompanies, []);

  useEffect(filterResults, [search, companiesList]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href={"/cpanel/resupply"}>
            {t("resupplyOrders.header")}
          </Link>

          <Typography color="textPrimary">
            {t("resupplyOrders.supplierCompanies")}
          </Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <TextField
            variant="outlined"
            label={t("search")}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>{t("companyList.header")}</Title>
          {width === "xs" ? (
            searchList && searchList.length ? (
              searchList
                .sort((a, b) =>
                  a.createdAt > b.createdAt
                    ? -1
                    : b.createdAt > a.createdAt
                    ? 1
                    : 0,
                )
                .map((val, i) => (
                  <ContactInfoBadge
                    key={i}
                    clientInfoObject={{
                      companyName: val.name,
                      location: val.location,
                      ...val.additionalInfo,
                    }}
                    onClick={() => {
                      showCompany(val);
                    }}
                    containerStyles={{ marginTop: 10 }}
                  />
                ))
            ) : null
          ) : searchList ? (
            <SortableTable
              headCells={[
                {
                  id: "name",
                  numeric: false,
                  disablePadding: false,
                  label: t("contactInfo.companyName"),
                },
                {
                  id: "location",
                  numeric: false,
                  disablePadding: false,
                  label: t("contactInfo.location"),
                },
                {
                  id: "additionalInfo",
                  numeric: false,
                  disablePadding: false,
                  label: t("additionalInfo"),
                },
              ]}
              specialDataFormatting={[
                {
                  id: "additionalInfo",
                  format: (data) => {
                    if (!data) {
                      return "";
                    }
                    return Object.values(data).filter(Boolean).join(" / ");
                  },
                },
              ]}
              defaultSortRow={"name"}
              handleRowClick={showCompany}
              tableData={searchList}
              rowsPerPage={200}
              defaultOrder={"asc"}
            />
          ) : undefined}
        </Paper>
      </Grid>
    </Grid>
  );
}

export default withWidth()(SupplierCompanies);
